import axios from 'axios';
import { toast } from 'sonner';
import { normalizeIndianMobile, phoneErrorMessage } from '@/utils/phone';

const API = process.env.REACT_APP_BACKEND_URL;
const ax = axios.create({ baseURL: API, withCredentials: true });

/** Submit walk-in check-in; returns receipt payload or null. */
export async function submitWalkinCheckin({
  selectedSession, mode, selectedExisting, pName, pPhone, pEmail, pAge, pGender,
  pRelationship, phoneValid, setPhoneTouched, bookingMode, slot, symptoms,
  showDiscount, rawDisc, discKind, discReason, discNote, discPreview, adminPin,
  discCfg, payMethod, payRef, feeTier, docName, resetPatientFields,
}) {
  if (!selectedSession) { toast.error('Pick a session first'); return { ok: false }; }
  let patientPayload;
  if (mode === 'pick') {
    if (!selectedExisting) { toast.error('Pick a patient from the matches'); return { ok: false }; }
    patientPayload = { patient_id: selectedExisting.id };
  } else {
    if (!pName.trim()) { toast.error('Patient name required'); return { ok: false }; }
    if (!phoneValid) {
      setPhoneTouched(true);
      toast.error(phoneErrorMessage(pPhone) || 'Enter a valid 10-digit mobile');
      return { ok: false };
    }
    patientPayload = {
      name: pName.trim(),
      phone: normalizeIndianMobile(pPhone),
      email: (pEmail || '').trim().toLowerCase() || null,
      age: pAge ? parseInt(pAge, 10) : null,
      gender: pGender,
      relationship: pRelationship,
    };
  }
  const discountPayload = (showDiscount && rawDisc > 0) ? {
    discount_amount: discKind === 'flat' ? rawDisc : 0,
    discount_percent: discKind === 'percent' ? rawDisc : 0,
    discount_reason: discReason || 'other',
    discount_note: discNote || null,
    admin_pin: discPreview.needsPin ? adminPin : null,
  } : null;
  if (discountPayload && discPreview.needsPin && !adminPin) {
    toast.error(`Admin PIN required for discounts above ${discCfg.approval_threshold_percent}%.`);
    return { ok: false };
  }
  const res = await ax.post('/api/clinic-ops/checkin', {
    session_id: selectedSession.id,
    patient: patientPayload,
    booking_mode: bookingMode,
    slot_start: bookingMode === 'slot' ? slot : null,
    symptoms: (symptoms || '').trim() || null,
    payment_amount: discPreview.final,
    payment_method: payMethod,
    payment_reference: payRef || null,
    discount: discountPayload,
  });
  const queueNo = res?.data?.queue_no;
  const patientName = mode === 'pick' ? (selectedExisting?.name || '') : pName.trim();
  toast.success(queueNo
    ? `Patient checked in · Queue #${queueNo}`
    : 'Patient checked in · Complete triage to issue queue number');
  const collected = discPreview.final;
  const receipt = collected > 0 ? {
    amount: collected, method: payMethod, reference: payRef,
    patient_name: patientName, queue_no: queueNo,
    purpose: feeTier === 'first_visit' ? 'First consultation'
      : feeTier === 'followup' ? 'Follow-up consultation' : 'Consultation',
    doctor_name: docName(selectedSession.doctor_id),
  } : null;
  resetPatientFields();
  return { ok: true, receipt };
}
